<template>
	<div class="class">
		<teacherNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></teacherNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="class_title flex">
					<p class="f30px cl_dark">学校资源库·试卷库</p>
				</div>
				<div class="task_cont_nav f18px cl_dark paper_my_nav">
					<div class="task_cont_nav_list cur" :class="{'on': nav_cur == 1}" @click="navCheck(1)">我的试卷库</div>
					<div class="task_cont_nav_list cur" :class="{'on': nav_cur == 2}" @click="navCheck(2)">公共试卷库</div>
					<div class="paper_my_nav_btn tc cl_white cur" @click="dialog_show=true">创建试卷</div>
				</div>
				<div class="task_subject cl_gray tc">
					<span class="task_subject_list bg_gray cur" v-for="(item,index) in subject" :key="index"
					 @click="subjectCheck(item.subjectId)" :class="{'on': subject_cur == item.subjectId}">{{item.subjectName}}</span>
				</div>
				<div class="task_paper_screen mat30">
					<div class="test_screen cl_gray">
						<div class="test_screen_l f16px"><span class="inline">试用年级</span><i class="inline">：</i></div>
						<div class="test_screen_r tc">
							<span class="test_screen_list bg_gray" v-for="(item,index) in grade" :key="index" :class="{'on':item.gradeId==grade_cur}"
							 @click="gradeCheck(item.gradeId)">{{item.gradeName}}</span>
						</div>
					</div>
				</div>
				<div class="f18px cl_gray mat30">共 <span class="cl_yel">{{total}}</span> 套试卷</div>
				<div class="flex paper_library_list_cont mat30" v-if="list.length > 0">
					<div class="paper_library_list radius8 bs flex mab30" v-for="(item,index) in list" :key="index">
						<div class="paper_library_list_l">
							<router-link :to="{ path: '/paper_edit', query: { id: item.id }}" class="f20px">{{item.name}}</router-link>
							<div class="cl_gray mat10">创建者：{{item.user_name}}</div>
						</div>
						<div class="paper_library_list_r tc" v-if="nav_cur == 1">
							<router-link :to="{ path: '/paper_found', query: { id: item.id }}" class="cl_violet paper_library_list_edit">编辑</router-link>
							<div class="flex paper_library_list_delete cl_red mat20 cur" @click="remove(item.id)">
								<img src="../../../static/delete_red.png" class="mar10" />
								<p>删除</p>
							</div>
						</div>
					</div>
				</div>
				<div class="famous_page flex" v-if="list.length > 0">
					<div class="famous_page_l f16px cl_gray"> </div>
					<div class="famous_page_r cl_dark">
						<el-pagination background layout="prev, pager, next, jumper"
						@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
					</div>
				</div>
				<div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
					<img src="../../../static/paper_empty.png" /><br>
					<p class="mat20 f18px cl_violet inline cur paper_my_empty_btn" @click="dialog_show=true">创建试卷</p>
				</div>
			</div>
		</div>
		<!-- 创建试卷 -->
		<el-dialog title="请选择试卷科目" :visible.sync="dialog_show" width="40%" center>
		  <div class="f16px paper_dialog_cont">
				<div class="test_screen cl_gray">
					<div class="test_screen_l f16px"><span class="inline">试用年级</span><i class="inline">：</i></div>
					<div class="test_screen_r tc">
						<span class="test_screen_list bg_gray" v-for="(item,index) in grade_two" :key="index" :class="{'on':item.gradeId==grade_cur_two.gradeId}"
						 @click="gradeTwoCheck(index)">{{item.gradeName}}</span>
					</div>
				</div>
				<div class="test_screen cl_gray">
					<div class="test_screen_l f16px"><span class="inline">所属学科</span><i class="inline">：</i></div>
					<div class="test_screen_r tc">
						<span class="test_screen_list bg_gray" v-for="(item,index) in subject" :key="index" :class="{'on':item.subjectId==subject_cur_two.subjectId}"
						 @click="subjectTwoCheck(index)">{{item.subjectName}}</span>
					</div>
				</div>
				<div class="test_screen cl_gray">
					<div class="test_screen_l f16px"><span class="inline">学生可见</span><i class="inline">：</i></div>
					<div class="test_screen_r tc">
						<input type="checkbox" v-model="student_see" class="paper_dialog_check" />
					</div>
				</div>
			</div>
		  <div slot="footer" class="f18px mab20">
		    <span @click="dialog_show = false" class="cl_violet cur inline paper_dialog_cancel">取 消</span>
		    <span @click="dialogConfirm" class="cl_white cur inline paper_dialog_confirm">立即创建</span>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import teacherNav from '../../components/teacher_nav.vue'
	
	export default {
		name: 'class_manage',
		components: {
			teacherNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 6,
					listCur: 2,
					open: 0,
				},
				nav_cur: 1,
				subject: [], //学科
				subject_cur: {},
				grade: [], //年级
				grade_cur: "",
				list: [],
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总页数
				dialog_show: false,
				subject_cur_two: "",
				grade_two: [],
				grade_cur_two: {},
				student_see: false,
			}
		},
		created() {
			
		},
		mounted() {
			this.getSubject();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			navCheck (e) {
				this.nav_cur = e;
				this.currentPage = 1;
				this.getSubject();
			},
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					this.subject = res.data;
					this.subject_cur = this.subject[0].subjectId;
					this.subject_cur_two = this.subject[0];
					this.getGrade();
				});
			},
			subjectCheck (e) {
				this.subject_cur = e;
				this.currentPage = 1;
				this.getGrade();
			},
			//年级
			getGrade () {
				this.$get("/api/teacher/get_school_grade_data",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.grade_two = [].concat(res.data);
					this.grade_cur_two = this.grade_two[0];
					this.grade = res.data;
					this.grade.unshift({gradeId: "", gradeName: "全部"});
					this.grade_cur = this.grade[0].gradeId;
					this.getList();
				});
			},
			gradeCheck (e) {
				this.grade_cur = e;
				this.currentPage = 1;
				this.getList();
			},
			//试卷
			getList () {
				this.$get("/api/teacher/get_examination_paper_list",{
					token: localStorage.getItem("token"),
					subject_id: this.subject_cur,
					grade_id: this.grade_cur,
					type: this.nav_cur,
					page: this.currentPage,
					limit: this.pageSize,
				})
				.then(res => {
					this.list = res.data.data;
					this.total = res.data.total;
				});
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getList();
			},
			gradeTwoCheck (e) {
				this.grade_cur_two = this.grade_two[e];
			},
			subjectTwoCheck (e) {
				this.subject_cur_two = this.subject[e];
			},
			dialogConfirm () {
				this.$router.push({path: '/paper_found', 
				query: {grade_id_str: this.grade_cur_two.gradeId, grade_name: this.grade_cur_two.gradeName, subject_id: this.subject_cur_two.subjectId,
				subject_name: this.subject_cur_two.subjectName, is_student_show: Number(this.student_see)}});
			},
			//删除
			remove (e) {
				this.$messageBox.confirm('删除试卷后，对于已经布置的作业学生仍可以正常作答，是否确定删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.$get("/api/teacher/post_examination_paper_del",{
						token: localStorage.getItem("token"),
						id: e,
					})
					.then(res => {
						this.$message({
							type: 'success',
							message: res.msg,
							duration: 1500,
						});
						setTimeout(() => {
							this.getList();
						}, 1500);
					});
				}).catch(() => {
					
				});
			},
		},
	}
</script>

<style>
</style>
